import { useCallback, useRef, useState } from "react";
import Loading from "../Loading";
import { getFileAcceptType, uploadMedia } from "../../../utils";

import { useAppContext } from "../../../providers/ProviderAppContainer";
import { ICON_SIZE, TEXT_NORMAL } from "../../../style";

function isImageAcceptType(type) {
    if (type === "image") {
        return true;
    }
    if (["video", "pdf", "sheet", "audio"].includes(type)) {
        return false;
    }
    return /\.(png|jpe?g|gif|webp)/i.test(getFileAcceptType(type));
}

export default function PlaceHolder({ label, type, setCDNUrl, setPreview, disabled, capture = "environment" }) {
    const fileInputRef = useRef(null);
    const cameraInputRef = useRef(null);

    const { showToast } = useAppContext();

    const [uploadProgress, setUploadProgress] = useState();
    const showCamera = isImageAcceptType(type);
    const accept = getFileAcceptType(type);

    const onFileSelected = useCallback(
        (event) => {
            const file = event.target?.files[0];
            event.target.value = "";
            if (file) {
                uploadMedia({
                    requestPath: `bucketise/${type}s`,
                    file,
                    onRequestEnd: false,
                    onRequestFailure: (error) => {
                        showToast({ severity: "error", summary: "Failed", detail: error, life: 2000 });
                        setUploadProgress(false);
                    },
                    onRequestStart: setUploadProgress,
                    parseResponseBody: true,
                    onProgress: setUploadProgress,
                    onResponseReceieved: ({ cdn_url }, responseCode) => {
                        if (cdn_url && responseCode === 201) {
                            showToast({ severity: "success", summary: "Uploaded", detail: "File Uploaded", life: 1000 });
                            setCDNUrl(cdn_url);
                            setPreview(URL.createObjectURL(file));
                        } else showToast({ severity: "error", summary: "Failed", detail: "Failed To Upload File !", life: 2000 });
                    },
                });
            }
        },
        [setCDNUrl, setPreview, showToast, type],
    );

    const openPicker = useCallback(
        (inputRef) => (event) => {
            event.stopPropagation();
            if (!disabled) {
                inputRef.current?.click();
            }
        },
        [disabled],
    );

    return uploadProgress ? (
        <Loading message={`Uploading ${uploadProgress}%`} />
    ) : (
        <div className="flex flex-column align-items-center justify-content-center gap-3">
            <div className="flex align-items-center justify-content-center gap-4">
                <i
                    className={`pi pi-cloud-upload border-circle bg-gray-200 text-gray-500 p-4 cursor-pointer ${ICON_SIZE}`}
                    title={`Select ${label}`}
                    onClick={openPicker(fileInputRef)}
                />
                {showCamera ? (
                    <i
                        className={`pi pi-camera border-circle bg-gray-200 text-gray-500 p-4 cursor-pointer ${ICON_SIZE}`}
                        title={`Capture ${label}`}
                        onClick={openPicker(cameraInputRef)}
                    />
                ) : null}
            </div>
            <span className={`${TEXT_NORMAL} text-gray-500`}>Select {label}</span>
            {!disabled && (
                <>
                    <input type="file" ref={fileInputRef} onChange={onFileSelected} accept={accept} style={{ display: "none" }} />
                    {showCamera ? (
                        <input
                            type="file"
                            ref={cameraInputRef}
                            onChange={onFileSelected}
                            accept={accept}
                            capture={capture}
                            style={{ display: "none" }}
                        />
                    ) : null}
                </>
            )}
        </div>
    );
}
